var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.name === 'projectDataStructuresCreate')?_c('Wizard'):(_vm.$route.name.includes('projectDataStructuresDetails'))?_c('Details'):(_vm.$route.name === 'projectDataStructuresEditor')?_c('Editor',{attrs:{"mock-data":false}}):_c('Table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }